// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1SymD","title":"AfterBackImages_title__3UVbF","images":"AfterBackImages_images__2JJls"};